import $ from 'jquery';
import { Fancybox } from '@fancyapps/ui';
import 'sharer.js';
import ClipboardJS from 'clipboard';
import 'jquery-parallax.js';
// eslint-disable-next-line no-unused-vars
import { Collapse, Modal } from 'bootstrap';

const clipBoard = new ClipboardJS('.vipers-clipboard');

clipBoard.on('success', function (e) {
    const $this = $(e.trigger);

    $this.addClass('vipers-clipboard-success');

    setTimeout(function () {
        $this.removeClass('vipers-clipboard-success');
    }, 3000);
});

$('.vipers-share-toggle').on('click', function () {
    $(this).parent().toggleClass('vipers-share-active');
});

$('.wp-block-gallery').each(function (i) {
    $(this).attr('data-block-gallery', i);
    const items = $(`[data-block-gallery=${i}]`).find(
        'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]'
    );
    items.attr('data-fancybox', `block-gallery-${i}`);

    Fancybox.bind(`[data-block-gallery=${i}]`, {
        // Your options go here
    });
});

const jsContainer = () => {
    if ($('.js-container').length) {
        const bodyWidth = $('body').outerWidth();
        $('.js-container').css({
            width: bodyWidth,
            marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
        });
    }
};

const goTop = (e) => {
    const scrollY = e.delegateTarget.scrollY;
    const button = $('.go-top');

    if (scrollY >= 160) {
        button.addClass('go-top-active');
    } else {
        button.removeClass('go-top-active');
    }
};

const allImageParents = $('.vipers-flow-out-image');
const flowOutImage = () => {
    const bodyWidth = $('body').outerWidth();

    for (let i = 0; i < allImageParents.length; i++) {
        const currentParent = allImageParents.eq(i);

        if (window.matchMedia('(min-width: 992px)').matches) {
            currentParent.css('width', bodyWidth / 2);
        } else {
            currentParent.css('width', '');
        }
    }
};

$(window).bind('resize', jsContainer).trigger('resize');
$(window).bind('scroll', goTop).trigger('resize');
$(window).bind('resize', flowOutImage).trigger('resize');

$('.go-top').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
});

$('a[href="#cookies"]').on('click', (e) => {
    e.preventDefault()
    window.openAxeptioCookies()
})

document.addEventListener('DOMContentLoaded', function () {
    const tel = document.querySelectorAll('[href^="tel:"]');
    if (tel.length) {
        tel.forEach((el) => {
            el.classList.add('gtm_phone')
        })
    }
    const maps = document.querySelectorAll('[href*="/maps/"]')

    if (maps.length) {

        maps.forEach((el) => {
            el.classList.add('gtm_itinerary')
        })
    }
    const mails = document.querySelectorAll('[href^="mailto:"]')

    if (mails.length) {
        mails.forEach((el) => {
            el.classList.add('gtm_mail')
        })
    }
})

